<template>
  <div class="cashflow-type-variable card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="variableExpenses.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="variableExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="true"
                      :out-of-date="true"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :recommended-title="titles.categorySections.recommendedTitle"
                                 :categories="variableExpenses.monthly.realExpenses.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :title="titles.categorySections.mainTitle"
                                 :out-of-date="true"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction-row class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="false"
                                     v-bind:key="transaction.transactionId">

          </transaction-row>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import PredictedTransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransacionRow.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import TransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';


export default {
  name: 'CashflowTypeEconomy',
  mixins: [CashflowAnalytics],
  components: {
    TransactionRow,
    ExpenseProgress,
    PredictedTransactionRow,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.variableExpense;
    },
    variableExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'מומלץ להוציא עד',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'מומלץ להוציא עד',
          mainTitle: 'פירוט הוצאות משתנות',
        },
        cardTitle: 'הוצאות משתנות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .out-of-date-cashflow-view-container {
    .cashflow-type-variable {
      @include cashflow-card;

      .title {
        color: $riseup_gray_2;
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_gray_2;
      }

      .cashflow-type-background-color {
        background-color: $riseup_gray_2;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/out-of-date-month/components/types/CashflowTypeVariableExpense.vue